import React from 'react'
import { Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Switch, Redirect } from 'react-router'
import { routes } from '../../../consts'
import SigninForm from './SignInForm'
import SignupForm from './SignupForm'
import ChoosePassword from './ChoosePassword'
import LoginWithOneTimeCode from './LoginWithOneTimeCode'
import VerifyOneTimeCode from './VerifyOneTimeCode'
import ResetPassword from './ResetPassword'
import ResetPasswordVerifyCode from './ResetPasswordVerifyCode'
import ResetAndChoosePassword from './ResetAndChoosePassword'
import VerifySSNCode from './VerifySSNCode'
import QuickSignUp from './QuickSignUp/QuickSignUp'
import SignupErrorPage from './SignupErrorPage'

import './GetStarted.css'

const GetStarted = () => {
  const phoneNumber = useSelector(state => state.auth.phoneNumber)
  return (
    <div className="get-started-page">
      <Switch>
        <Route exact path={routes.SIGN_IN} component={SigninForm} />
        <Route exact path={routes.SIGN_UP} component={SignupForm} />
        <Route exact path={routes.SIGN_UP_ERROR} component={SignupErrorPage} />
        <Route exact path={routes.CHOOSE_PASSWORD} component={ChoosePassword} />
        <Route exact path={routes.SSN} component={VerifySSNCode} />
        <Route exact path={routes.QUICK_SIGN_UP} component={QuickSignUp} />
        <Route
          exact
          path={routes.ONE_TIME_LOGIN}
          component={LoginWithOneTimeCode}
        />
        <Route exact path={routes.VERIFY_ONE_TIME_CODE}>
          {phoneNumber ? (
            <VerifyOneTimeCode />
          ) : (
            <Redirect to={routes.ONE_TIME_LOGIN} />
          )}
        </Route>
        <Route exact path={routes.RESET_PASSWORD} component={ResetPassword} />
        <Route
          exact
          path={routes.RESET_PASSWORD_VERIFY_CODE}
          component={ResetPasswordVerifyCode}
        />

        <Route
          exact
          path={routes.RESET_AND_CHOOSE_NEW_PASSWORD}
          component={ResetAndChoosePassword}
        />
      </Switch>
    </div>
  )
}

export default GetStarted
